module.exports = __webpack_public_path__ + "src/img/sigfloSymbolPurple.858d7f74.svg";